import React from "react";

import { IChildrenNode } from "config";

import { IConditionalWrapperProps } from "./types";

const ConditionalWrapper: React.FC<IConditionalWrapperProps & IChildrenNode> =
  ({
    condition,
    wrapper,
    children,
  }: IConditionalWrapperProps & IChildrenNode) => {
    return <>{condition ? wrapper(children) : children}</>;
  };

export default ConditionalWrapper;
